/** Default and suggested Kobiton API environments. */
export const DEFAULT_API_URL = 'https://api.kobiton.com';

export const API_URL_OPTIONS = [
  'api.kobiton.com',
  'proxy-api-public-grpc-server-test.kobiton.com',
] as const;

/**
 * Turn a host or URL entered on the login page into a canonical API base URL.
 * Bare hosts use HTTPS. Paths are supported for custom reverse proxies.
 */
export function normalizeApiUrl(value?: string | null): string {
  const entered = value?.trim();
  if (!entered) return DEFAULT_API_URL;

  let url: URL;
  try {
    url = new URL(/^[a-z][a-z\d+.-]*:\/\//i.test(entered) ? entered : `https://${entered}`);
  } catch {
    throw new Error('Enter a valid API URL.');
  }

  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    throw new Error('The API URL must use HTTP or HTTPS.');
  }
  if (url.username || url.password || url.search || url.hash) {
    throw new Error('The API URL cannot contain credentials, a query, or a fragment.');
  }

  return url.toString().replace(/\/$/, '');
}

/** Convert an HTTP API base URL to the matching WebSocket endpoint. */
export function websocketUrl(baseApiUrl: string): string {
  const url = new URL(normalizeApiUrl(baseApiUrl));
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = `${url.pathname.replace(/\/$/, '')}/ws`;
  return url.toString();
}
